import { CSSProperties, ReactNode } from 'react';

import { ApiStatus } from 'core/enums';
import { ButtonType, Size } from 'coreOld/enums';
import { useAppSelector } from 'coreOld/hooks';

import ButtonView from './ButtonView';

interface IProps {
  id?: string;
  onClick?;
  onMouseDown?;
  disabled?: boolean;
  size?: Size;
  btnType?: ButtonType;
  children?: ReactNode;
  style?: CSSProperties;
  hasMarginRight?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
}

const Button = ({
  id,
  onClick,
  onMouseDown,
  disabled,
  size,
  btnType = ButtonType.ACTION,
  children,
  style,
  hasMarginRight = false,
  fullWidth = true,
  fullHeight = false,
}: IProps) => {
  const { notification } = useAppSelector((state) => state.notification);

  const handleOnClick = (event) => {
    event.target.blur();

    onClick && onClick(event);
  };

  const handleOnMouseDown = (event) => {
    event.target.blur();

    onMouseDown && onMouseDown(event);
  };

  return (
    <ButtonView
      id={id}
      onClick={handleOnClick}
      onMouseDown={handleOnMouseDown}
      disabled={disabled || notification?.type === ApiStatus.LOADING}
      size={size}
      btnType={btnType}
      style={style}
      hasMarginRight={hasMarginRight}
      fullWidth={fullWidth}
      fullHeight={fullHeight}
    >
      {children}
    </ButtonView>
  );
};

export default Button;
